'use client';

import { useField } from 'formik';
import { FC, useRef } from 'react';

import { debounce } from '@/utils/debounce';

import { Input } from './Input';
import { InputFormikProps } from './Input.type';

/**
 * Input field expected to be used within a Formik context
 */
export const InputFormik: FC<InputFormikProps<typeof Input>> = ({ onTrackingEvent, ...props }) => {
  const [field, meta] = useField(props.name);
  const onEventTracking = useRef(
    debounce((value) => {
      onTrackingEvent?.(value);
    }, 500),
  );
  return (
    <Input
      {...props}
      value={field.value}
      error={meta.error && meta.touched ? meta.error : undefined}
      onChange={(e: string | React.ChangeEvent<any>) => {
        field.onChange(e);

        if (typeof e === 'string') {
          onEventTracking.current(e);
        }
      }}
      onBlur={field.onBlur}
    />
  );
};
